import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export function fetchHazmatClasses() {
  const url = ApiUrl('v2/hazard_class');

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { hazmat_classes: 'hazmat_classes_data' } }
  );
}

export function fetchUNNumbers(formData) {
  const url = ApiUrl(`v2/organization_hazmat_classes?organization_id=${formData.organization_id}`);

  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { un_numbers: "hazmat_materials" } }
  );
}

// Master HazmatMaterial catalog (GET /v2/hazmat_materials). `query` matches UN
// number or proper shipping name; the API only filters once it is 3+ characters.
export function fetchMasterUNNumbers({ organization_id, query } = {}) {
  const params = [];
  if (organization_id) params.push(`organization_id=${encodeURIComponent(organization_id)}`);
  if (query) params.push(`query=${encodeURIComponent(query)}`);
  const url = ApiUrl(`v2/hazmat_materials${params.length ? `?${params.join("&")}` : ""}`);

  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { un_numbers: "hazmat_materials" } }
  );
}

// Link master HazmatMaterial records onto the organization.
//   POST /v2/organization_hazmat_classes
//   { organization_id, un_number_ids: [hazmat material id, ...] }
//   -> { message, hazmat_materials: [...] }
// isPassOrgId=false so Call does not also inject org_id (backend only uses organization_id).
export function addOrganizationUNNumbers({ organization_id, un_number_ids }) {
  const url = ApiUrl("v2/organization_hazmat_classes");

  return Call(
    "post",
    url,
    {
      organization_id,
      un_number_ids: (un_number_ids || []).map(String).filter(Boolean),
    },
    ParseGeneralResponse,
    { responseDataKeys: { un_numbers: "hazmat_materials", message: "message" } },
    false
  );
}

// Remove one organization UN number.
//   DELETE /v2/organization_hazmat_classes/:id?organization_id=
// isPassOrgId=false so Call does not also inject org_id (backend only uses organization_id).
export function deleteOrganizationUNNumber({ id, organization_id }) {
  const url = ApiUrl(
    `v2/organization_hazmat_classes/${encodeURIComponent(id)}?organization_id=${encodeURIComponent(organization_id)}`
  );

  return Call(
    "delete",
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { message: "message" } },
    false
  );
}
